"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var PassthruRtePluginsRecord = (0, _immutable.Record)({
  type: null,
  plugins: (0, _immutable.Seq)(),
  pluginComposers: (0, _immutable.Seq)()
}, 'PassthruRtePlugins');

var PassthruRtePlugins =
/*#__PURE__*/
function (_PassthruRtePluginsRe) {
  (0, _inherits2.default)(PassthruRtePlugins, _PassthruRtePluginsRe);

  function PassthruRtePlugins() {
    (0, _classCallCheck2.default)(this, PassthruRtePlugins);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PassthruRtePlugins).apply(this, arguments));
  }

  (0, _createClass2.default)(PassthruRtePlugins, [{
    key: "getRteConfigType",
    value: function getRteConfigType(interactionType) {
      return this.type || interactionType;
    }
  }, {
    key: "concatPlugins",
    value: function concatPlugins(plugins) {
      return this.set('plugins', this.plugins.concat(plugins));
    }
  }, {
    key: "concatPluginComposers",
    value: function concatPluginComposers(pluginComposers) {
      return this.set('pluginComposers', this.pluginComposers.concat(pluginComposers));
    }
  }]);
  return PassthruRtePlugins;
}(PassthruRtePluginsRecord);

exports.default = PassthruRtePlugins;
module.exports = exports.default;